<form [formGroup]="dataForm" class="without-default-focus">
    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Attribut</mat-label>
            <mat-select formControlName="attribute" required tabindex="1" (selectionChange)="onSelectedAttributeChange($event)">
                <mat-option *ngFor="let attribute of _attributes" [value]="attribute.id">
                    {{ attribute.header }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="dataForm.controls['attribute']?.errors?.required && (dataForm.controls['attribute']?.dirty || dataForm.controls['attribute'].touched)">
                Le champ 'Attribut' est obligatoire
            </mat-error>
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO État" matTooltipPosition="right"></fa-icon>
    </div>

    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Condition sur la valeur de l'attribut</mat-label>
            <mat-select formControlName="condition" required tabindex="2" (selectionChange)="onConditionChange($event)">
                <mat-option [value]="AllValue">Quelle que soit la valeur</mat-option>
                <mat-option [value]="SpecificValue">Valeur spécifique</mat-option>
            </mat-select>
            <mat-error *ngIf="dataForm.controls['condition']?.errors?.required && (dataForm.controls['condition']?.dirty || dataForm.controls['condition'].touched)">
                Le champ 'Condition sur la valeur de l'attribut' est obligatoire
            </mat-error>
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO État" matTooltipPosition="right"></fa-icon>
    </div>

    <div class="form-item form-item-help" *ngIf="selectedAttribute && dataForm.get('condition').value !== AllValue">
        <ng-container *ngIf="mode !== FormMode.Reading">
            <!-- Affichage d'un attribut de type 'Texte' -->
            <ng-container
                *ngIf="
                    selectedAttribute.type !== propertyType.Long &&
                    selectedAttribute.type !== propertyType.Decimal &&
                    selectedAttribute.type !== propertyType.Date &&
                    selectedAttribute.type !== propertyType.DateAndTime &&
                    selectedAttribute.type !== propertyType.List &&
                    selectedAttribute.type !== propertyType.ListCustomers &&
                    selectedAttribute.type !== propertyType.Color &&
                    selectedAttribute.type !== propertyType.AutocompletionByApi &&
                    selectedAttribute.type !== propertyType.ListUsers
                ">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <input matInput type="text" formControlName="value" autocomplete="off" required />
                    <mat-error *ngIf="dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                    <mat-error *ngIf="dataForm.controls['value']?.hasError('pattern')">
                        <span title="Le champ doit respecter l'expression régulière : {{ selectedAttribute.format }}.">
                            Le champ doit respecter l'expression régulière : {{ selectedAttribute.format }}.
                        </span>
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <!-- Affichage d'un attribut de type 'Entier' -->
            <ng-container *ngIf="selectedAttribute.type === propertyType.Long">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <input matInput type="number" formControlName="value" autocomplete="off" required />
                    <mat-error *ngIf="dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                    <mat-error *ngIf="dataForm.controls['value']?.hasError('invalidError')">
                        <span title="La valeur n'est pas un nombre entier valide.">La valeur n'est pas un nombre entier valide.</span>
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <!-- Affichage d'un attribut de type 'Decimal' -->
            <ng-container *ngIf="selectedAttribute.type === propertyType.Decimal">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <input matInput type="number" formControlName="value" autocomplete="off" required />
                    <mat-error *ngIf="dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                    <mat-error *ngIf="dataForm.controls['value']?.hasError('invalidError')">
                        <span title="La valeur n'est pas un nombre décimal valide.">La valeur n'est pas un nombre décimal valide.</span>
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <!-- Affichage d'un attribut de type 'Date' -->
            <ng-container *ngIf="selectedAttribute.type === propertyType.Date">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <input matInput [matDatepicker]="datepicker" formControlName="value" required />
                    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                    <mat-datepicker #datepicker></mat-datepicker>
                    <mat-error *ngIf="dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <!-- Affichage d'un attribut de type 'Date & heure' -->
            <ng-container *ngIf="selectedAttribute.type === propertyType.DateAndTime">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <input matInput [ngxMatDatetimePicker]="picker" formControlName="value" required />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <ngx-mat-datetime-picker #picker></ngx-mat-datetime-picker>
                    <mat-error *ngIf="dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <!-- Affichage d'un attribut de type 'Liste' -->
            <ng-container *ngIf="selectedAttribute.type === propertyType.List && selectedAttribute.custom === true">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <mat-select formControlName="value" required>
                        <mat-option [value]="">Aucune</mat-option>
                        <mat-option *ngFor="let attributeValue of selectedAttribute.attributeValueDefinitions" [value]="attributeValue.id.toString()">
                            {{ attributeValue.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <!-- Affichage de l'attribut 'Etat' -->
            <ng-container *ngIf="selectedAttribute.type === propertyType.List && selectedAttribute.name === 'FolderStateId'">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <mat-select formControlName="value" required>
                        <mat-option [value]="">Aucune</mat-option>
                        <mat-option *ngFor="let state of _folderStates" [value]="state.id.toString()">{{ state.name }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <!-- Affichage de l'attribut 'Etat' -->
            <ng-container *ngIf="selectedAttribute.type === propertyType.ListUsers">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <mat-select formControlName="value" required>
                        <mat-option [value]="">Aucune</mat-option>
                        <mat-option *ngFor="let user of _users" [value]="user.id.toString()">{{ user.displayName }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <!-- Affichage d'un attribut de type 'Client' -->
            <ng-container *ngIf="selectedAttribute.type === propertyType.ListCustomers">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <mat-select formControlName="value" required>
                        <mat-option [value]="">Aucune</mat-option>
                        <mat-option *ngFor="let attributeValue of selectedAttribute.attributeValueDefinitions" [value]="attributeValue.id.toString()">
                            {{ attributeValue.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <!-- Affichage d'un attribut de type 'Couleur' -->
            <ng-container *ngIf="selectedAttribute.type === propertyType.Color">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <mat-select formControlName="value" ngClass="bak-{{ dataForm.get('value').value }}-color" required>
                        <mat-option value="">Aucune</mat-option>
                        <mat-option class="mat-option-green-color" value="green"></mat-option>
                        <mat-option class="mat-option-orange-color" value="orange"></mat-option>
                        <mat-option class="mat-option-red-color" value="red"></mat-option>
                        <mat-option class="mat-option-grey-color" value="grey"></mat-option>
                        <mat-option class="mat-option-light-blue-color" value="lightBlue"></mat-option>
                        <mat-option class="mat-option-dark-blue-color" value="darkBlue"></mat-option>
                    </mat-select>
                    <mat-error *ngIf="dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                </mat-form-field>
            </ng-container>

            <!-- Affichage d'un attribut de type 'Autocompletion par API' -->
            <ng-container *ngIf="selectedAttribute.type === propertyType.AutocompletionByApi">
                <mat-form-field class="with-info-icon">
                    <mat-label>Valeur</mat-label>
                    <input matInput type="text" formControlName="value" [matAutocomplete]="auto" />
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (closed)="onAutocompleteClosed()" (optionSelected)="onAutocompleteItemSelected($event)">
                        <mat-option *ngFor="let autocompletionValue of autocompletionValues | async" [value]="autocompletionValue">{{ autocompletionValue }}</mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="dataForm.controls['value']?.errors?.required && (dataForm.controls['value']?.dirty || dataForm.controls['value'].touched)">
                        Le champ 'Valeur' est obligatoire
                    </mat-error>
                </mat-form-field>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="mode === FormMode.Reading">
            <!-- Non géré -->
        </ng-container>

        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Valeur" matTooltipPosition="right"></fa-icon>
    </div>
</form>
